import React from 'react';
import { ComparisonPageType } from 'store/ui-stores/comparison/comparisonStore';
import { PageHeader, useQueryParams } from '@insurancemenu/imenu-components-lib';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { PRODUCT_LINES_CONTENT_MAP } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { toJS } from 'mobx';
import { useHistory } from 'react-router-dom';
import { PortfolioQuantityStyled } from './styles';

export interface ComparisonHeaderProps {
  type: ComparisonPageType;
}
export interface HeaderInfo {
  title: string;
  subtitle: string | JSX.Element;
}
export type HeaderTitlesMap = {
  [key in ComparisonPageType]: HeaderInfo;
};

const ComparisonHeader = observer(({ type }: ComparisonHeaderProps): JSX.Element => {
  const query = useQueryParams();
  const productLineId = query.get('productLineId') || null;
  const eeClass = query.get('eeClass') || '';
  const {
    comparisonStore: { loading, loaderInPortfolioId, filteredPortfolios },
  } = useRootStore();
  const history = useHistory();
  const portfoliosQuantity = filteredPortfolios.map((portfolio) => toJS(portfolio)).slice().length;
  const TotalPortfoliosQuantity = (
    <span>
      Total compared plans:<PortfolioQuantityStyled>{portfoliosQuantity}</PortfolioQuantityStyled>
    </span>
  );

  const headerTitles: HeaderTitlesMap = Object.freeze({
    cart: {
      title: 'Compare Added Plans',
      subtitle: TotalPortfoliosQuantity,
    },
    variants: {
      title: 'Current Plan Variants',
      subtitle: '',
    },
    portfolios: {
      title: 'Compare Selected Plans',
      subtitle: TotalPortfoliosQuantity,
    },
    details: {
      title: 'Plan Details',
      subtitle: '',
    },
    'config-portfolio': {
      title: 'Portfolio Configurations',
      subtitle: '',
    },
    proposal: {
      title: 'Compare Added Plans',
      subtitle: TotalPortfoliosQuantity,
    },
    'proposal-details': {
      title: 'Plan Details',
      subtitle: '',
    },
    ee: {
      title: 'Plan Details',
      subtitle: '',
    },
    'all-portfolios': {
      title: `Compare All ${
        productLineId ? PRODUCT_LINES_CONTENT_MAP[productLineId as ProductLineId].label : ''
      } Plans`,
      subtitle: TotalPortfoliosQuantity,
    },
    'available-products': {
      title: 'Plan Summary',
      subtitle: eeClass ? `Class: ${eeClass}` : '',
    },
  });

  return (
    <PageHeader
      title={(type && headerTitles[type]?.title) || ''}
      subtitle={(type && headerTitles[type]?.subtitle) || ''}
      disableBackButton={loading || !!loaderInPortfolioId}
      onBackButtonClick={history.goBack}
      subtitleMaxWidth="50rem"
    />
  );
});

export default ComparisonHeader;
